import { LangMap } from './language.types';

export const APP_LANGS = ['en', 'fr', 'nl', 'it', 'ro', 'de', 'pl'] as const;
export const DEFAULT_LANG = 'en';
export const TEL_LANG_MAP: LangMap<string> = {
  en: '+421 910 727 034',
  ro: '+40 758 207 095',
};

export const MAIL_LANG_MAP: LangMap<string> = {
  en: 'info@pygmalios.com',
  ro: 'info.ro@pygmalios.com',
};
